<template>
  <section id="content">
    <PageTitle :title="$t('tools/shipping.title')"></PageTitle>
    <div class="wrapper wrapper-content animated fadeInRight">

      <div class="row">
          <div class="col-lg-12">
            <ShipTracking></ShipTracking>
          </div>
      </div>

    </div>

  </section>
</template>

<style scoped>
  
</style>


<script lang="ts">
import Vue from '@fwk-node-modules/vue';
import { Component, Watch } from '@fwk-node-modules/vue-property-decorator';
import { mixins } from '@fwk-node-modules/vue-class-component';
import GenericPage from '@fwk-client/components/mixins/GenericPage.vue';
import PageTitle from '../../panels/PageTitle.vue';
import ShipTracking from '../../panels/tools/ShipTracking.vue';

@Component({
  components: {
    PageTitle,
    ShipTracking
  }
})
export default class Shipping extends mixins(GenericPage) {

}
</script>